// 3T ships each Extrema frameset with its own cockpit: Italia_X (naked carbon)
// finishes get the Uno Ghiaia, the painted Italia finishes Superghiaia + More 2.
// Neither fits other frames.
const UNO = '3T Uno Ghiaia', SUPERGHIAIA = '3T Superghiaia Integrale + More 2';

export const isExtremaCockpit = name => name === UNO || name === SUPERGHIAIA;

export function extremaCockpitName(frame, colorIndex = 0) {
  if (!/^3T Extrema Italia\b/.test(frame && frame.name || '')) return null;
  const choice = frame.colors && frame.colors[colorIndex];
  const name = choice && (choice.colorName || choice.color && choice.color.colorName) || '';
  return /Italia[ _]?X\b/i.test(name) ? UNO : SUPERGHIAIA;
}

export function extremaBarsForFrame(bars, frame, colorIndex = 0) {
  const preferred = extremaCockpitName(frame, colorIndex);
  return bars.filter(bar => !isExtremaCockpit(bar.name) || bar.name === preferred);
}

function withBar(selection, bar, steps) {
  const stepIndex = steps.findIndex(step => step.id === 'bars');
  const step = steps[stepIndex];
  const entry = { props: step, selected: 0, item: { ...bar, type: 'bars', step }, color: 0 };
  const next = selection.slice(), index = next.findIndex(item => item.props.id === 'bars');
  if (index >= 0) next.splice(index, 1, entry);
  else next.splice(Math.min(stepIndex, next.length), 0, entry);
  return next;
}

// Called only on a user frame selection, never when restoring a saved build.
export function preselectExtremaCockpit(selection, frame, bars, steps, colorIndex = 0) {
  const preferred = extremaCockpitName(frame, colorIndex);
  const options = extremaBarsForFrame(bars, frame, colorIndex);
  const current = selection.find(entry => entry.props.id === 'bars');
  const next = selection.filter(entry => entry.props.id !== 'bars' || options.some(bar => bar.id === entry.item.id));
  if (!steps.some(step => step.id === 'bars')) return next;
  const removed = current && isExtremaCockpit(current.item.name) && !next.includes(current);
  const bar = preferred ? options.find(item => item.name === preferred)
    : removed ? options.find(item => /enve/i.test(item.name || '')) || options[0] : null;
  if (!bar || (current && current.item.id === bar.id)) return next;
  return withBar(next, bar, steps);
}

// A finish change swaps one included 3T cockpit for the other, but keeps a
// deliberately chosen alternative handlebar. Returns the same array if unchanged.
export function matchExtremaFinish(selection, frame, bars, steps, colorIndex) {
  const preferred = extremaCockpitName(frame, colorIndex);
  const current = selection.find(entry => entry.props.id === 'bars');
  if (!preferred || !current || !isExtremaCockpit(current.item.name) || current.item.name === preferred) return selection;
  const bar = bars.find(item => item.name === preferred);
  return bar ? withBar(selection, bar, steps) : selection;
}
